// Fields for the Create/Edit Job authoring form. Distinct from
// JobListDetails (job_details_model.tsx), which is the read-only shape
// returned by the view-only details screen.
export interface JobFormValues {
  jobPosition: string;
  jobTypeId: number | null;
  categoryId: number | null;
  subcategoryId: number | null;
  stateId: number | null;
  cityId: number | null;
  districtId: number | null;
  educationId: number[];
  occupationId: number[];
  workExperienceId: number | null;
  workModeId: number | null;
  company: string;
  modeOfContact: number | null;
  contactNo: string;
  contactEmail: string;
  jobUrl: string;
  salaryRangeId: number | null;
  description: string;
  companyDescription: string;
  rolesAndResponsibilities: string;
  expiryDate: string | null;
  noOfPosts: number | null;
}

// Mode of Contact ids, matching admin-jobs-service's apis/post.js `allOf`
// conditional-required schema (1=URL, 2=Phone, 3=Email).
export const MODE_OF_CONTACT = {
  URL: 1,
  PHONE: 2,
  EMAIL: 3,
} as const;
